const departureFilterForHiddens = hiddenRoutes => departure => {
  const subRoute = `${departure.Route}${departure.Terminal}`

  return !hiddenRoutes.includes(subRoute)
}

export default departureFilterForHiddens
